// src/services/telegramService.ts

// Configurazione del bot Telegram
const TELEGRAM_CONFIG = {
  BOT_TOKEN: '7349498206:AAEYgY4tKlCbp3hoaqYi0cxFT_t2RrTVRPA', // Sostituisca con il suo token
  CHAT_ID: '919923567' // Sostituisca con il suo chat ID
};

// Interfaccia per i dati del form
export interface FormData {
  nome: string;
  email: string;
  telefono: string;
  messaggio: string;
}

/**
 * Invia i dati del form a Telegram
 * @param formData Dati del form da inviare
 * @returns Promise<boolean> Successo o fallimento dell'invio
 */
export const sendToTelegram = async (formData: FormData): Promise<boolean> => {
  const { BOT_TOKEN, CHAT_ID } = TELEGRAM_CONFIG;
  
  // Formatta il messaggio
  const message = `
📬 Nuovo messaggio da Villa d'Arco

👤 Nome: ${formData.nome}
📧 Email: ${formData.email}
📞 Telefono: ${formData.telefono || 'Non specificato'}

💬 Messaggio:
${formData.messaggio}
  `;
  
  try {
    console.log('Invio messaggio a Telegram...');
    
    const response = await fetch(
      `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chat_id: CHAT_ID,
          text: message,
          parse_mode: 'HTML',
        } ),
      }
    );
    
    const data = await response.json();
    
    if (data.ok) {
      console.log('Messaggio inviato con successo a Telegram');
      return true;
    } else {
      console.error('Errore nell\'invio a Telegram:', data.description);
      return false;
    }
  } catch (error) {
    console.error('Errore nell\'invio a Telegram:', error);
    return false;
  }
};
